<template>
  <b-container fluid class="simple-ribbon">
    <b-row class="my-5" align-h="center" v-for="item in content" :key="item.title">
      <b-col cols="10">
        <p class="title" v-if="item.item">{{ item.title }}</p>
        <div v-html="sanitizedContent(item.content)"></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    content: Array
  },
  methods: {
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    }
  }
}
</script>

<style scoped src="@/assets/css/simple-ribbon.css"/>
